import {DateMapper} from "@app/core/shared/infrastructure/mappers/date.mapper";
import {MyOrderHeader} from "../../domain/dtos/my-order-header";

export class OrderHeaderMapper {
    static deserialize(param: any): MyOrderHeader {
        return {
            orderDate: DateMapper.deserialize(param.orderData),
            deliveryDate: DateMapper.deserialize(param.deliveryDate),
            statusCode: param.status,
            statusName: param.statusTitle,
            orderImport: param.orderImport,
            orderNumber: param.orderNumber
        } as MyOrderHeader
    }
}
